import React, { useContext, useEffect, useState } from 'react';
import moment from "moment";
import 'moment-timezone';
import 'moment/locale/es';

import { Row, Col, Button } from "react-bootstrap";

import { PDFDownloadLink } from '@react-pdf/renderer'
import CertificateSeniorityView from "../../components/CertificateSeniority"
import CertificateSeniorityPDF from "../../components/CertificateSeniority/PDF"

import CustomCard from '../../components/CustomCard'
import Loading from '../../components/Loading'

import UserContext from '../../context/User/UserContext';
import jsonParams from '../../config/_cetificateSeniority'
import {formatedRun} from '../../utils/RunUtil'

const CertificateSeniority = () => {
    
    const userContext = useContext(UserContext);
    const { user, loading, getDataUser } = userContext;

    const [ data, setData ] = useState(jsonParams)

    useEffect( () => {  
        if(!user) {getDataUser();}
        else {replaceText(); }
        // eslint-disable-next-line
    }, [user])

    const replaceText = () => {
        
        let hiringDate = new Date(user.contract.hiringDate);
        hiringDate = hiringDate.setDate(hiringDate.getDate() + 1);
        let firstText = data.firstText.replace('%_fullName_%', `${user.firstName} ${user.lastName} ${user.surName}`)
                         .replace('%_rut_%', `${formatedRun(user.run)}`)
                         .replace('%_workPosition_%', `${user.contract.workPosition}`)
                         .replace('%_type_contract_%', `${user.contract.typeContract}`)
                         .replace('%_date_admission_%', getDateFormated('', hiringDate))
        let date = getDateFormated('Santiago, ', new Date());
        setData({...data, firstText, date})
    }

    const getDateFormated = (beforeText, date) => {
        const day= moment(date).format('DD');
        const month=moment(date).format('MMMM');
        const year=moment(date).format('YYYY');
        let format = `${beforeText}${day} de ${month} de ${year}`;
        return format;    
    }
    
    return ( 
        <>
        <Row>
            <Col lg={12} >                     
                <Button className={"col-lg-12"}  disabled={loading} variant="outline-info">
                    {loading ? 'Descargar Certificado' : 
                        <PDFDownloadLink document={
                            <CertificateSeniorityPDF 
                                logoImg={data.logoImg}
                                signatureImg={data.signatureImg} 
                                title={data.title}
                                firstText={data.firstText} 
                                secondText={data.secondText}
                                representative={data.representative}
                                workPosition={data.workPosition} 
                                business={data.business}
                                date={data.date}                                
                            />
                            } fileName="certificado.pdf">
                        {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Descargar Certificado')}
                        </PDFDownloadLink>
                    }
                </Button>              
            </Col>
        </Row>
        <br></br>
           
        <CustomCard>
            { loading ? 
                <Loading /> :
                <CertificateSeniorityView 
                    logoImg={data.logoImg}
                    signatureImg={data.signatureImg} 
                    title={data.title}
                    firstText={data.firstText} 
                    secondText={data.secondText}
                    representative={data.representative}
                    workPosition={data.workPosition} 
                    business={data.business}
                    date={data.date}
                />
            }
           
        </CustomCard>
        </>
     );
}
 
export default CertificateSeniority;